//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.CombOptionsBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Features.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AngularThreshold",0,"Expression",0],[1,"CombOptions",0,"GeometricUtilities.CombOptionsBuilder",0],[0,"CurvatureCheck",1,0],[1,"DistanceThreshold",0,"Expression",0],[0,"DynamicLabel",0,"Features.GeometricConstraintDataManager",0],[1,"Face",0,"SelectNXObjectList",0],[1,"FirstEdge",0,"SelectNXObjectList",0],[0,"G0",1,0],[0,"G0Tolerance",1,0],[0,"G1",1,0],[0,"G1Tolerance",1,0],[0,"G2",1,0],[0,"G2Tolerance",1,0],[0,"G3",1,0],[0,"G3Tolerance",1,0],[1,"MultiFace",0,"SelectNXObjectList",0],[0,"ReportPer",1,0],[1,"SecondEdge",0,"SelectNXObjectList",0],[0,"ShowOutOfTolerance",1,0],[0,"ToleranceMarkup",1,0],[0,"Type",1,0]],[[["edge_or_face","selection_point"],"UpdateFirstEdgeFace",{},2,0],[["edge_or_face","selection_point"],"UpdateSecondEdgeFace",{},2,0],[["face","selection_point"],"UpdateFace",{},2,0],[["n_faces"],"GetFace1Array",{R_:{faces:"Face[]"}},0,0],[["edge","face"],"DeselectFirstEdgeFace",{},2,0],[["edge","face"],"SelectFirstEdgeFace",{},2,0],[["edge","face"],"DeselectSecondEdgeFace",{},2,0],[["edge","face"],"SelectSecondEdgeFace",{},2,0],[["continuity"],"GetGxResult",{R_:{isGxGood:''}},1,0]],[]];
SPLM.GeometricAnalysis.SurfaceContinuityAnalysisBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.SurfaceContinuityAnalysisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.SurfaceContinuityAnalysisBuilder.Types = Object.freeze({
    "EdgeToEdge" : "EdgeToEdge", "EdgeToFace" : "EdgeToFace", "MultiFace" : "MultiFace"});

SPLM.GeometricAnalysis.SurfaceContinuityAnalysisBuilder.CurvatureType = Object.freeze({
    "Sectional" : "Sectional", "Gaussian" : "Gaussian", "Mean" : "Mean", "Absolute" : "Absolute"});

SPLM.GeometricAnalysis.SurfaceContinuityAnalysisBuilder.ReportingType = Object.freeze({
    "Analysis" : "Analysis", "Pair" : "Pair"});

export default SPLM;